import { _ as _asyncToGenerator, a as _regeneratorRuntime } from './asyncToGenerator-c002e3ca.esm.js';
import Auth from '@aws-amplify/auth';

var secureRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(client, requestType, requestEndPoint, requestParams, requestBody) {
    var isCognitoSecurity,
      headers,
      forcedPayload,
      payload,
      requestObject,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          isCognitoSecurity = _args.length > 5 && _args[5] !== undefined ? _args[5] : false;
          headers = _args.length > 6 && _args[6] !== undefined ? _args[6] : {};
          forcedPayload = _args.length > 7 ? _args[7] : undefined;
          _context.prev = 3;
          if (!isCognitoSecurity) {
            _context.next = 13;
            break;
          }
          if (forcedPayload) {
            _context.next = 11;
            break;
          }
          _context.next = 8;
          return Auth.currentSession();
        case 8:
          payload = _context.sent;
          _context.next = 12;
          break;
        case 11:
          payload = forcedPayload;
        case 12:
          client.setHeaders({
            Authorization: "Bearer ".concat(payload.idToken.jwtToken),
            Accept: "*/*"
          });
        case 13:
          requestObject = {
            method: requestType,
            url: requestEndPoint,
            headers: headers
          };
          if (requestParams) requestObject.params = requestParams;
          if (requestBody) requestObject.data = JSON.stringify(requestBody);
          return _context.abrupt("return", client.any(requestObject));
        case 19:
          _context.prev = 19;
          _context.t0 = _context["catch"](3);
          console.error("Error in secureAPI", _context.t0);
          throw _context.t0;
        case 23:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 19]]);
  }));
  return function secureRequest(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();

export { secureRequest as s };
